import * as React from 'react'

function SvgInvertColorsOffRounded(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.94 4.7v4.05l7.4 7.4c1.15-2.88.59-6.28-1.75-8.61l-4.94-4.95a.996.996 0 00-1.41 0L8.5 5.31l1.41 1.41 2.03-2.02zm-8.31-.02a.996.996 0 000 1.41l2.08 2.08a8.003 8.003 0 00.57 10.68 8.011 8.011 0 005.66 2.33c1.78 0 3.56-.59 5.02-1.77l2 2A.996.996 0 1020.37 20L5.05 4.68c-.39-.39-1.03-.39-1.42 0zM7.7 17.43a5.928 5.928 0 004.24 1.76v-4.8L7.15 9.6a5.907 5.907 0 00-1.21 3.59c0 1.6.62 3.1 1.76 4.24z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgInvertColorsOffRounded
